import React, { useState, useCallback } from 'react';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { datetimeFormat } from '@tokenyico/design-system';
import { formActions, holderActions } from 'app/state/actions';
import { HolderService } from 'services';

import { TransactionTypeCell } from 'app/components';
import BigNumber from 'bignumber.js';
import TableWrapper from 'app/components/TableWrapper/TableWrapper';
import { hasValuation } from 'app/helpers/hasValuation';
import { DsNumber } from '@tokenyico/design-system/dist/reactJS';

const DashboardTransactions = ({ selectedToken, setError }) => {
  const { t } = useTranslation();

  const [transactions, setTransactions] = useState([]);

  const loadData = useCallback(async () => {
    try {
      const transactions = await HolderService.getTransactions(selectedToken.id, { limit: 3 });
      setTransactions(transactions.items);
    } catch (e) {
      setError(e);
    }
  }, [selectedToken.id, setError]);

  const header = [
    {
      key: 'date',
      label: t('shared.date'),
      isSortable: false,
    },

    {
      key: 'amount',
      label: t('shared.amount'),
      isSortable: false,
    },
    {
      key: 'type',
      label: t('shared.type'),
      isSortable: false,
    },
  ];

  return (
    <div>
      {transactions && transactions.length > 0 && (
        <div className="_flex-row _flex-justify-between">
          <div className="table__title">
            <h2 className="h5">{t('shared.transactions')}</h2>
          </div>
          <div className="_flex-row">
            <NavLink to="/transactions">
              <small className="_text-grey-900">{t('shared.seeAll')}</small>
            </NavLink>
          </div>
        </div>
      )}
      <TableWrapper
        height="100%"
        width="100%"
        header={header}
        data={transactions}
        onFetchData={loadData}
        noData={() => (
          <div className="empty-state">
            <span className="text-secondary">{t('shared.noTransactions')}</span>
          </div>
        )}
        date={({ row }) => datetimeFormat(row.datetime)}
        amount={({ value }) =>
          value ? (
            <div>
              {<DsNumber number={value} />}{' '}
              {hasValuation(selectedToken) && selectedToken.currency ? (
                <span className="_text:xs _text-grey-800">
                  (
                  {
                    <DsNumber
                      number={new BigNumber(value)
                        .multipliedBy(selectedToken.lastValuationPrice.valuation)
                        .toFixed(2)}
                      currency={selectedToken.currency}
                    />
                  }
                  )
                </span>
              ) : (
                ''
              )}
            </div>
          ) : (
            '-'
          )
        }
        type={({ value }) => <TransactionTypeCell type={value} />}
      />
    </div>
  );
};

const mapToProps = ({ setError, holder: { selectedToken } }) => ({
  setError,
  selectedToken,
});

export default connect(
  mapToProps,
  combineActions(formActions, holderActions),
)(DashboardTransactions);
